import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import { usePortalAccess } from './usePortalAccess';

/** `/me` 실패(503·네트워크)는 group 0 이 아니다 — 판정 불가를 알리고 리다이렉트하지 않는다 */
const Undecidable = ({ onRetry }: { onRetry: () => void }) => (
  <Box role="alert" p={3}>
    권한 판정 불가 — 권한 정보를 불러오지 못했습니다. 잠시 후 다시 시도하고, 계속되면 관리자에게 문의하세요.
    <Box mt={2}>
      <Button variant="outlined" onClick={onRetry}>다시 시도</Button>
    </Box>
  </Box>
);

/** team group 이 하나도 없고 portal-admin 도 아닌 사용자(group 0) */
export const isGroupZero = (me?: { teams: string[]; isPortalAdmin: boolean }) => !me || (me.teams.length === 0 && !me.isPortalAdmin);

/**
 * 메뉴 권한 가드. 권한이 없으면 group 0 은 `/access-request`, 그 밖은 `/home` 으로 보낸다(`/me` 실패면 보내지 않고 안내).
 * 사이드바 노출·API 가드(R3 policy)와 같은 판정(`/me` 의 permissions)을 쓴다 — 실제 차단은 서버.
 */
export const MenuRoute = ({ menu, children }: PropsWithChildren<{ menu: string }>) => {
  const { loading, me, error, has, retry } = usePortalAccess();
  if (loading) return null;
  if (error) return <Undecidable onRetry={retry} />;
  if (!has(menu)) return <Navigate to={isGroupZero(me) ? '/access-request' : '/home'} replace />;
  return <>{children}</>;
};

/** `/` 진입: group 0 은 권한 신청으로, 그 밖은 홈으로 */
export const RootRedirect = () => {
  const { loading, me, error, retry } = usePortalAccess();
  if (loading) return null;
  if (error) return <Undecidable onRetry={retry} />;
  return <Navigate to={isGroupZero(me) ? '/access-request' : '/home'} replace />;
};
